import {useCallback, useMemo} from 'react'
import {requestData} from 'services'
import {useDispatch, useSelector} from 'lib/redux'
import {showModalRoboyuLevelUp} from '../../../components'

export function useRoboyuCustomizationHooks() {
  const {update} = useDispatch()
  const {hasLocallyCountedExp} = useSelector('generalAccountState') || {}
  const {lv: level} = useSelector('roboyuState')
  const handleFetchRoboyuCustomizationStatus = useCallback(async (hasClearedExpTask?: boolean) => {
    const hasClearedExpTaskLocally = hasClearedExpTask || !!hasLocallyCountedExp
    const response = await requestData('roboyu_customization_status')
    if (typeof response !== 'string' && response.status === 200) {
      const {exp, lv, skin_id, skin_name} = response.data.result
      if (level > 1 && level < lv && !!hasClearedExpTaskLocally) {
        showModalRoboyuLevelUp()
      }
      update('roboyuState', {
        colorTheme: {name: skin_name, skin_id},
        exp,
        lv,
      })
      update('generalAccountState', {hasLocallyCountedExp: false})
      return lv
    }
    return undefined
  }, [hasLocallyCountedExp, level, update])
  return useMemo(() => ({handleFetchRoboyuCustomizationStatus}), [handleFetchRoboyuCustomizationStatus])
}
